import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './auth/AuthProvider';
import { msalInstance } from './auth/msalConfig';

// Reset default browser styles
const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; }
  body { margin: 0; padding: 0; background: #f3f4f6; }
  dt { font-weight: 600; color: #6b7280; font-size: 12px; }
  dd { margin: 0; color: #111827; }
`;
document.head.appendChild(style);

// MSAL v3+ requires explicit initialization before first render
msalInstance.initialize().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
});
